import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';

import { fetchMatches as fetchMatchesApi } from '@apis/matches';
import { Order } from '@shared-types/common.types';
import type { RoundPhase } from '@shared-types/match.types';
import { dateToString } from '@utilities/dateTime';

export type FetchMatchesParams = {
  competitionIds: string[];
  seasonYear?: string;
  phase?: RoundPhase | 'ALL';
  roundId?: string | string[];
  fromDate?: Dayjs;
  toDate?: Dayjs;
  order?: Order;
  offset?: number;
  limit?: number;
};

export const fetchMatches = (
  {
    competitionIds,
    seasonYear,
    phase,
    roundId,
    fromDate,
    toDate,
    order = Order.ASC,
    offset = 0,
    limit = 500,
  }: FetchMatchesParams,
  signal: AbortSignal,
) => {
  const filters = {
    competitionId: competitionIds,
    seasonYear,
    phase,
    roundId,
    fromDate: dateToString(fromDate),
    toDate: dateToString(toDate),
    utcOffset: fromDate && toDate ? Math.max(dayjs(fromDate).utcOffset(), dayjs(toDate).utcOffset()) / 60 : undefined,
    order,
    offset,
    limit,
  };
  return fetchMatchesApi(filters, signal);
};
